
import React, { Fragment, useEffect, useRef } from 'react';
import { useWindowResizeObserver } from '../../../../domain/animations/animations-provider';
import {rootActions, useAppDispatch, useAppSelector} from "../DAL/store";
import {initEqualHeight} from "../../../list-page/services/list-page-provider";
import Server from "./server";
import TR_ROW from "./tr-row";
import TR_ROW_TITLE from "./tr-row-title";

const tdHideMutualStyle= {
    width: '20%',
    verticalAlign: 'bottom',
    height: 'inherit,'
};

const Table = () => {
    const dispatch = useAppDispatch();
    const pcWrap = useAppSelector(store => store.pcWrap);
    const isMutualHidden = useAppSelector(store => store.isMutualHidden);
    console.log('pcWrap: ',pcWrap);

    const [ width ] = useWindowResizeObserver();
    const containerRef = useRef<HTMLTableElement>(null);

    /**
     * titles and taglines should have equal height in grid view
     */
    useEffect(() => {
        (async () => {
            await initEqualHeight(
                containerRef.current,
                width,
                'grid',
                4,
                4,
                4
            );
        })();
    }, [
        // update on every jPList action changes,
        // on document width change, and on products change
        width,
    ]);

    const toggleMutual = () => {
        dispatch(
            rootActions.main({
                isMutualHidden: !isMutualHidden,
            })
        );
    };

    const serversCount = pcWrap?.productCompareUnionList.length || 0;
    const emptyServers = 4 - serversCount;

    return (
        <div className="w-screen lg:w-full overflow-auto">
            <table className="w-1200-px md:w-full h-full" ref={ containerRef }>
                <tbody>
                <tr>
                    <td style={ tdHideMutualStyle }>
                        {/*<button type="button" className="w-btn w-auto mb-4" onClick={ toggleMutual }>*/}
                        {/*    { isMutualHidden && <span>Show Mutual</span> }*/}
                        {/*    { !isMutualHidden && <span>Hide Mutual</span> }*/}
                        {/*</button>*/}
                    </td>

                    {
                        pcWrap?.productCompareUnionList.map(unionItem => <Server productCompareUnion={ unionItem } key={ unionItem.documentID } /> )
                    }

                    {
                        emptyServers > 0 &&
                        <>{[...Array(emptyServers)].map((_el, index) => {
                            return <td key={ `empty-${ index }` }></td>
                        })}</>
                    }
                </tr>

                {/*Dimensions*/}
                {<TR_ROW_TITLE productCompareUnionList={pcWrap?.productCompareUnionList} propTitle="Dimensions" emptyServers={emptyServers}  />}
                {<TR_ROW productCompareUnionList={pcWrap?.productCompareUnionList} propName="dimLength" propTitle="Length" emptyServers={emptyServers}  />}
                {<TR_ROW productCompareUnionList={pcWrap?.productCompareUnionList} propName="dimHeight" propTitle="Height" emptyServers={emptyServers}  />}
                {<TR_ROW productCompareUnionList={pcWrap?.productCompareUnionList} propName="dimDeviceWeight" propTitle="Device Weight" emptyServers={emptyServers}  />}
                {<TR_ROW productCompareUnionList={pcWrap?.productCompareUnionList} propName="dimPackageWeight" propTitle="Package Weight" emptyServers={emptyServers}  />}

                {/*eMotion LV1*/}
                {<TR_ROW_TITLE productCompareUnionList={pcWrap?.productCompareUnionList} propTitle="eMotion LV1*" emptyServers={emptyServers} propDescr="eMo plugins (eMo D5, F2, Q4) inserted on all input, aux & bus channels:"  />}
                {<TR_ROW productCompareUnionList={pcWrap?.productCompareUnionList} propName="lV1CPU16" propTitle="16 channels" emptyServers={emptyServers}  />}
                {<TR_ROW productCompareUnionList={pcWrap?.productCompareUnionList} propName="lV1CPU32" propTitle="32 channels" emptyServers={emptyServers}  />}
                {<TR_ROW productCompareUnionList={pcWrap?.productCompareUnionList} propName="lV1CPU64" propTitle="64 channels" emptyServers={emptyServers}  />}

                {/*SuperRack SoundGrid*/}
                {<TR_ROW_TITLE productCompareUnionList={pcWrap?.productCompareUnionList} propTitle="SuperRack SoundGrid**" emptyServers={emptyServers} />}
                {<TR_ROW productCompareUnionList={pcWrap?.productCompareUnionList} propName="spksgC616" propTitle="C6 - 16 Racks" emptyServers={emptyServers}  />}
                {<TR_ROW productCompareUnionList={pcWrap?.productCompareUnionList} propName="spksgC632" propTitle="C6 - 32 Racks" emptyServers={emptyServers}  />}
                {<TR_ROW productCompareUnionList={pcWrap?.productCompareUnionList} propName="spksgC664" propTitle="C6 - 64 Racks" emptyServers={emptyServers}  />}
                {<TR_ROW productCompareUnionList={pcWrap?.productCompareUnionList} propName="spksghreV16" propTitle="H-Reverb - 16 Racks" emptyServers={emptyServers}  />}
                {<TR_ROW productCompareUnionList={pcWrap?.productCompareUnionList} propName="spksghreV32" propTitle="H-Reverb - 32 Racks" emptyServers={emptyServers}  />}
                {<TR_ROW productCompareUnionList={pcWrap?.productCompareUnionList} propName="spksghreV64" propTitle="H-Reverb - 64 Racks" emptyServers={emptyServers}  />}

                </tbody>
            </table>
            <div className="mt-12">
                <div className="mt-1">
                    * Tested with eMotion LV1 at 48 kHz / latency optimiszed mode / SGS buffer size 40
                </div>
                <div className="mt-1">
                    ** Tested with SuperRack SoundGrid at 48 kHz / SGS buffer size 40
                </div>
            </div>
        </div>
    )
};

export default Table;